





















































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { errorHandling } from '@/helpers/errorHandling';
import { validEmail } from '@/helpers/validEmail';
import { ICfm, MedicoParmDTO } from '@/interfaces/doctor';
import DoctorModel from '@/models/doctor-model';
import * as service from '@/services/doctors';
import { getUFs } from '@/services/utils';
import {
  ERROR_CODE_CFM_CRM_NOT_FOUND, ERROR_CODE_CFM_FAIL
} from '@/settings/consts/api-error';
import {
  MESSAGE_CFM_ERROR,
  MESSAGE_CFM_INVALID, MESSAGE_TITLE_CFM_ERROR, MESSAGE_TITLE_CFM_INVALID
} from '@/settings/consts/messages';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { PermissionAuth, UiAutocompleClientsSubsidiaries },
})
export default class DoctorForm extends BaseComponent {
  @Prop({
    default: false,
  })
  public isEdit: boolean;
  @Prop({
    default: false,
  })
  public isView: boolean;
  @Prop()
  public editItem: any;
  @Prop()
  public subsidiary?: any;

  private wasActive: boolean = false;

  public form: any = {
    valid: false,
    rules: {
      crm: [(v) => !!v || 'Digite o CRM'],
      crm_uf: [(v) => !!v || 'Digite o UF do CRM'],
      nome: [(v) => !!v || 'Informe o Nome do Médico'],
      email: [
        (v) => !!v || 'Digite o e-mail',
        (v) => !v || validEmail(v) || 'Digite um e-mail válido.',
      ],
      clients: [(v) => (!!v && v.length > 0) || 'Selecione uma unidade'],
      motivoInativacao: [(v) => !!v || 'Informe o motivo'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: DoctorModel = new DoctorModel();
  public ufs: any[] = [];
  public cfmLoading: boolean = false;
  public cfmError: boolean = false;
  public cfmErrorMessage: any = {
    title: MESSAGE_TITLE_CFM_INVALID(),
    message: MESSAGE_CFM_INVALID,
  };

  get cfmUpdateDate(): string {
    return !!this.item.cfm && !!this.item.cfm.dataAtualizacaoCfm
      ? dateFormat(this.item.cfm.dataAtualizacaoCfm)
      : null;
  }

  get cfmLastIntegration(): string {
    return !!this.item.cfm && !!this.item.cfm.ultimaIntegracao
      ? dateFormat(this.item.cfm.ultimaIntegracao, 'BR-TIME')
      : null;
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new DoctorModel(val);
    this.wasActive = this.item.ativo;
    this.setSubsidiary();
    this.getCfmInformations();
  }

  public beforeMount() {
    this.getUFs();
  }

  public onChangeCrm(): void {
    this.getCfmInformations();
  }

  public onChangeCrmUF(): void {
    this.getCfmInformations();
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    const onError = (error) => {
      this.loader.stop();
      this.showToastApiError(error);
    };

    let payload: MedicoParmDTO = new MedicoParmDTO();
    payload.crm = this.item.crm;
    payload.crmUF = this.item.crmUF;
    payload.ativo = this.item.ativo;
    payload.motivoInativacao = this.item.motivoInativacao;
    payload.nome = this.item.nome;
    if (!this.item.unidadesCliente) {
      this.item.unidadesCliente = [];
    }
    payload.idsUnidadesClientes = this.item.unidadesCliente.map(uc => Number(uc.id));

    if (!this.item.id) {
      service.saveDoctor(payload).subscribe((data) => {
        this.loader.stop();
        this.$emit('save', new DoctorModel(data));
        this.resetForm();
      }, onError);
    } else {
      service.updateDoctor(payload).subscribe((data) => {
        this.loader.stop();
        this.$emit('save');
        this.resetForm();
      }, onError);
    }
  }

  private resetForm() {
    setTimeout(() => {
      this.$refs.form.resetValidation();
    }, 100);
    this.cfmError = false;
    this.cfmErrorMessage = false;
  }

  public closeForm(): void {
    const closeAction = () => {
      this.$emit('close');
      this.resetForm();
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private resetAdditionalData(): void {
    if (!this.isEdit && !this.isView) {
      const emptyItem = new DoctorModel();
      emptyItem.crm = this.item.crm;
      emptyItem.crmUF = this.item.crmUF;
      this.item = emptyItem;
    }

    this.setSubsidiary();
  }

  private getCfmInformations(): void {

    this.resetAdditionalData();

    if (!this.item.crm || !this.item.crmUF) {
      return;
    }

    this.cfmLoading = true;
    this.cfmError = false;

    this.setCfmInformations({
      nome: this.item.nome,
      situacao: null,
      dataAtualizacaoCfm: null,
      ultimaIntegracao: null,
      liberado: this.item.ativo,
      tipoInscricao: null,
    });

    const onError = (error) => {
      this.cfmLoading = false;
      this.cfmError = true;
      setTimeout(() => {
        this.$refs['nomeMedico'].focus();
      }, 300);

      const errorMessages = {
        default: MESSAGE_CFM_ERROR,
        [ERROR_CODE_CFM_FAIL]: !!error.data
          ? error.data.message
          : MESSAGE_CFM_ERROR,
        [ERROR_CODE_CFM_CRM_NOT_FOUND]: !!error.data
          ? error.data.message
          : MESSAGE_CFM_ERROR,
      };

      const message = errorHandling(error, errorMessages);

      this.cfmErrorMessage = {
        title: MESSAGE_TITLE_CFM_ERROR,
        message,
      };
    };

    service
      .getCfmInformations({
        crm: this.item.crm,
        crmUF: this.item.crmUF,
      })
      .subscribe((data) => {        
        this.cfmLoading = false;
        this.cfmError = false;

        if (!data.liberado) {
          this.cfmErrorMessage = {
            title: MESSAGE_TITLE_CFM_INVALID(`(${data.situacao})`),
            message: MESSAGE_CFM_INVALID,
          };
        }

        this.setCfmInformations(data);
        if (data.liberado && data.idMedico) {
          this.cfmLoading = true;          
          service.getDoctor(data.idMedico.toString()).subscribe(data => {
            this.item = new DoctorModel(data);
            this.cfmLoading = false;
          }, error => {
            this.cfmLoading = false;
          });
        }
      }, onError);
  }

  private setSubsidiary(): void {
    if (!!this.subsidiary) {
      this.item.unidadesCliente.push(this.subsidiary);
    }
  }

  private setCfmInformations(data: ICfm): void {
    const nameUpper = !!data && !!data.nome ? data.nome.toUpperCase() : '';
    this.item.nome = nameUpper;

    if (!data.liberado) {
      this.item.ativo = false;
    } else if (this.isEdit || this.isView) {
      this.item.ativo = this.editItem.ativo;
    } else {
      this.item.ativo = true;
    }

    this.item.cfm = {
      ...data,
      nome: nameUpper,
    };
  }

  private getUFs(): any {
    getUFs().subscribe(
      (data) => {
        this.ufs = data;
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os UFs', 'error');
      },
    );
  }

  private isShowMotivoInativo() {
    return this.item && !this.item.ativo && (this.wasActive || this.item.motivoInativacao);
  }
}
